<app-products-top></app-products-top>
<div class="max-w-screen-2xl mx-auto">
  <app-pyg-offering></app-pyg-offering>
  <app-subscribe [place]="'products page'"></app-subscribe>
</div>
<app-try-demo></app-try-demo>
